import { Reducer } from 'redux';

import { ApiNotice, ApiNotices } from 'api/types';

import { NotificationBarState } from './noticesReducerUtilsPure';

import type { Chains } from 'reduxState/exchange/exchangeActiveChainUtils';

// State

const defaultState: NotificationBarState = {
  bannersGlobal: {},
  notificationsGlobal: {},
  customNotifications: {},
};

// Actions

export const setNoticesFromServer = (notices: ApiNotices, chain: Chains) =>
  ({
    type: 'NOTICES_SET',
    notices,
    chain,
  }) as const;

export const dismissNotice = (
  noticeType: 'notifications' | 'banners',
  id: string,
  chain: Chains
) =>
  ({
    type: 'NOTICES_DISMISS',
    noticeType,
    id,
    // originalId: id,
    // chainSpecificId: getChainNoticeId(id, chain),
    chain,
  }) as const;

// export const closePowerHourNotice = () =>
//   ({ type: 'CLOSE_POWER_HOUR_NOTICE' }) as const;

export const resetCustomNotifications = () =>
  ({ type: 'RESET_CUSTOM_NOTIFICATIONS' }) as const;

type NoticesAction = ReturnType<
  | typeof setNoticesFromServer
  | typeof dismissNotice
  | typeof resetCustomNotifications
>;

// Reducer @cached

export const noticesReducer: Reducer<NotificationBarState, NoticesAction> = (
  state = defaultState,
  action
): NotificationBarState => {
  switch (action.type) {
    case 'NOTICES_SET': {
      const notifications = action.notices.notifications.reduce(
        (notifications, notification) => {
          notifications[notification.id] = notification;
          return notifications;
        },
        {} as Record<string, ApiNotice>
      );
      const banners = action.notices.banners.reduce(
        (banners, banner) => {
          banners[banner.id] = banner;
          return banners;
        },
        {} as Record<string, ApiNotice>
      );
      return {
        ...state,
        bannersGlobal: banners,
        notificationsGlobal: notifications,
      };
      // if (action.chain === 'xchainEVMChain') {
      //   return {
      //     ...state,
      //     notificationsPolygon: notifications,
      //     bannersPolygon: banners,
      //   };
      // } else if (action.chain === 'ethereumChain') {
      //   return {
      //     ...state,
      //     notificationsEth: notifications,
      //     bannersEth: banners,
      //   };
      // } else if (action.chain === 'binanceChain') {
      //   return {
      //     ...state,
      //     bannersBsc: banners,
      //     notificationsBsc: notifications,
      //   };
      // } else {
      //   throw new Error('Unimplemented chain for notices');
      // }
    }
    case 'NOTICES_DISMISS': {
      const notificationStateProperty =
        action.noticeType === 'banners'
          ? 'bannersGlobal'
          : 'notificationsGlobal';
      const { [action.id]: removedNotification, ...notifications } =
        state[notificationStateProperty];
      if (!removedNotification?.isDismissable) {
        return state;
      }
      return {
        ...state,
        [notificationStateProperty]: notifications,
      };
    }
    // case 'CLOSE_POWER_HOUR_NOTICE':
    //   return {
    //     ...state,
    //     customNotifications: {
    //       powerHourClosedTs: Date.now(),
    //     },
    //   };
    case 'RESET_CUSTOM_NOTIFICATIONS':
      return {
        ...state,
        customNotifications: {},
      };
    default:
      return state;
  }
};
